<div class="maplibre-realtime-container">
  @if (liveOption?.enabled) {
    <div class="nodes-current-date">{{ currentDisplayedTime }}</div>
  }

  <div class="map-view-control">
    <select
      class="map-view-select"
      [(ngModel)]="mapViewMode"
      (ngModelChange)="onMapViewChange($event)"
    >
      @for (mode of mapViewModes; track $index) {
        <option [value]="mode.value">
          {{ mode.label | translate }}
        </option>
      }
    </select>
  </div>

  <app-extended-map-options
    class="extended-map-options-host"
    (showNodesEvent)="onShowNodesChange($event)"
    (showWindDirEvent)="onShowWindDirChange($event)"
    (zoneRiskType)="onZoneRiskTypeChange($event)"
    (showAirNowSensorsEvent)="showAirNowSensors($event)"
  ></app-extended-map-options>

  @if (activePlayOption && zonesList.length) {
    <div class="mapping-group-select-container">
      <select [(ngModel)]="selectedZoneId" (ngModelChange)="onZoneChange()">
        @for (zone of zonesList; track trackById($index, zone)) {
          <option [value]="zone.id">
            {{ zone.name }}
          </option>
        }
      </select>
    </div>
  }

  @if (showFloors && floorLevels.length > 1) {
    <div class="floor-level-container">
      <ul>
        @for (level of floorLevels; track $index) {
          <li
            (click)="changeFloorLevel(level)"
            [class.selected]="selectedFloorLevel === level.floor"
          >
            {{ level.floor }}
          </li>
        }
      </ul>
    </div>
  }

  @if (loading) {
    <div class="spinner-outer">
      <div class="spinner-cover">
        <div class="spinner-section">
          <mat-progress-spinner
            [color]="spinnerColor"
            [diameter]="spinnerDiameter"
            [mode]="spinnerMode"
            [strokeWidth]="spinnerStrokeWidth"
            [value]="spinnerValue"
          ></mat-progress-spinner>
        </div>
      </div>
    </div>
  }

  <div #mapContainer id="maplibre-realtime" class="maplibre-map"></div>
</div>

@if (showPlayOption && !loading) {
  <div class="video-progressbar-wrap d-flex">
    <span class="control-btn" (click)="startPlay()">
      <span class="material-symbols-outlined">{{ isPlaying ? 'pause' : 'play_arrow' }}</span>
    </span>
    @if (dustLayer.length) {
      <div class="progress" [class.scrollable]="dustLayer.length > 30">
        @for (value of dustLayer; track $index; let i = $index) {
          <div
            class="progress-bar"
            role="progressbar"
            [style]="'width: calc(' + 100 / dustLayer.length + '% - 1px)'"
            [class.selected]="currentKmlIndex != null && i === currentKmlIndex"
            [class.overflowed]="dustLayer.length > 30"
            [attr.aria-valuenow]="'width: calc(' + 100 / dustLayer.length + '% - 1px)'"
            aria-valuemin="0"
            aria-valuemax="100"
            (click)="showKmlFile(i)"
          >
            <span class="progress-value">{{ value.currTime }}</span>
            @if (i == 0 || value.currDate != dustLayer[i - 1].currDate) {
              <span class="progress-date">{{
                value.currDate
              }}</span>
            }
          </div>
        }
      </div>
    }
    <div class="date">
      <span>{{
        dustLayer[currentKmlIndex || 0].currDate + ' | ' + dustLayer[currentKmlIndex || 0].currTime
      }}</span>
    </div>
  </div>
}
